export class EnvironmentCondition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ScalarOperators",
            "format": ""
        },
        {
            "name": "environments",
            "baseName": "environments",
            "type": "Array<Environment>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EnvironmentCondition.attributeTypeMap;
    }
    constructor() {
    }
}
